export const RIG_ACTIVITY_COLORS = {
  'Slide Drilling': '#0085e3',
  'Rotary Drilling': '#4840d1',
  'In Slips': '#909f98',
  Circulating: '#9500b7',
  'Run in Hole': '#f70000',
  'Pull out of Hole': '#940000',
  'Reaming Up': '#38732e',
  'Dry Reaming Up': '#2e7357',
  'Reaming Down': '#5dd94b',
  'Dry Reaming Down': '#4bd984',
  'Washing Up': '#efd34b',
  'Washing Down': '#e99100',
  'Idle Off Bottom': '#d2dfd8',
  'Dry Rotary Off Bottom': '#a55d84',
  'Rotary Off Bottom': '#f28ac2',
  'Idle On Bottom': '#d2dfd8',
  'Static On Bottom': '#d2dfd8',
  'Static Off Bottom': '#79827d',
  'Circulating On Bottom': '#2dc7d5',
  'Dry Rotary On Bottom': '#05a0ae',
  'Circ. & Rot. On Bottom': '#0cebff',
  'Running Casing': '#e837f3',
  'Casing Trip In': '#f8a2fd',
  Cementing: '#47c7cf',
  // Legacy data defines
  'Reaming Upwards': '#38732e',
  'Dry Reaming Upwards': '#2e7357',
  'Reaming Downwards': '#5dd94b',
  'Dry Reaming Downwards': '#4bd984',
  'Washing Upwards': '#efd34b',
  'Washing Downwards': '#e99100',
  'Drilling Slide': '#0085e3',
  'Drilling Rotary': '#4840d1',
  Connection: '#909f98',
  'Run out of Hole': '#940000',
  Other: '#d2dfd8',
  Unclassified: '#d2dfd8',
  'Non Recognized time': '#8572FF',
};
